var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSales(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.65501 1.62296C7.17201 1.08746 7.89251 0.748715 8.68651 0.748715C9.74526 0.748715 10.6628 1.33971 11.1553 2.21371C11.5803 2.02296 12.054 1.91821 12.5553 1.91821C14.4638 1.91821 16.0053 3.47571 16.0053 5.39646C16.0053 7.31721 14.455 8.87496 12.55 8.87496C12.3226 8.87469 12.0957 8.852 11.8728 8.80721C11.4418 9.57671 10.617 10.0997 9.66876 10.0997C9.27476 10.0997 8.89926 10.0072 8.56676 9.84971C8.12976 10.8777 7.10776 11.6042 5.91926 11.6042C4.68176 11.6042 3.62301 10.8225 3.21926 9.72046C3.03895 9.75751 2.85533 9.77611 2.67126 9.77596C1.19426 9.77372 7.22503e-06 8.56746 7.22503e-06 7.07121C-0.00108505 6.59856 0.121687 6.13388 0.356093 5.72345C0.5905 5.31302 0.928357 4.97117 1.33601 4.73196C1.16976 4.35646 1.07751 3.93771 1.07751 3.49446C1.07126 1.78921 2.46876 0.397465 4.18001 0.397465C4.65908 0.396719 5.13183 0.506931 5.56118 0.719461C5.99054 0.931992 6.36484 1.24107 6.65476 1.62246",
    fill: "#00A1E0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales);
export default __webpack_public_path__ + "static/media/sales.ee618b31df4fc6452c1de025b2241930.svg";
export { ForwardRef as ReactComponent };